module.exports = __webpack_public_path__ + "googleAuth@2x.be41e2983f950e2cc2f57ba8afd4f4c8.png";